// Liste complète des emplacements SESAM

export const emplacementsData = {
  deroulants: [
    { id: 1, name: "Avenue de l'Indépendance (devant la BEAC)" },
    { id: 2, name: "Avenue des martyrs (devant l'hôpital l'hôpital communautaire)" },
    { id: 3, name: "Avenue B Boganda (devant Orange)" },
    { id: 4, name: "Route de d'église cathédrale" },
    { id: 5, name: "Avenue des martyrs (Devant l'hôpital Communautaire)" },
    { id: 6, name: "Devant le lycée français CDG" },
    { id: 7, name: "Route Avenue TOUADERA" },
    { id: 8, name: "Route Ambassade USA (RN6)" },
    { id: 9, name: "Avenue de l'independence (Devant Bangui mall)" },
    { id: 10, name: "Bd du général de gaule (devant l'hotel OUBANGUI)" }
  ],
  led: [
    { id: 11, name: "Aeroport Mpoko" },
    { id: 12, name: "Hotel LEDGER" },
    { id: 13, name: "Centre commercial Bangui mall" }
  ],
  grandFormat: [
    { id: 14, name: "PKO" }
  ],
  panneauxPoteaux: [
    { id: 15, name: "Avenue de France" },
    { id: 16, name: "Avenue de l'indépendance" },
    { id: 17, name: "Avenue B Boganda" },
    { id: 18, name: "Avenue D Dacko" }
  ]
};
